(function () {
    const playPauseBtns = document.getElementsByClassName("playpause")
    for (let i = 0; i < playPauseBtns.length; i++) {
        playPauseBtns[i].addEventListener("click", () => {
            handlePlayPause(playPauseBtns[i])
        })
    }

    function handlePlayPause(playPauseBtn) {
        const pauseEl = playPauseBtn.querySelector(".pause")
        const playEl = playPauseBtn.querySelector(".play")
        const paused = !pauseEl.classList.contains("show")
        const video = pauseEl.closest(".video").querySelector("video")
        if (paused) {
            video.play()
            pauseEl.classList.add("show")
            playEl.classList.add("hide")
            if (pauseEl.closest(".video").requestFullscreen) {
                pauseEl.closest(".video").requestFullscreen()
            }
        } else {
            video.pause()
            pauseEl.classList.remove("show")
            playEl.classList.remove("hide")
        }
    }
})();